import PropTypes from 'prop-types'
import React from 'react'
import classes from './Categories.scss'
import Button from 'components/Button'
import List from 'components/BetterList'

export class Categories extends React.Component {
  getRowLink = o => {
    return `/categories/${o.id}/edit`
  };

  getRowColumns = (o, i, a) => {
    return [ o.name, o.priority ]
  };

  render () {
    return (
      <div className={classes['collection']}>
        <header className={classes['header']}>
          <div className={classes['header-title']}>
            Browsing Categories
            <span className={classes['header-title--unimportant']}> – {this.props.categories.length}</span>
          </div>

          <div className={classes['header-buttons']}>
            <Button options={['green', 'small']} element='a' href='/categories/new'>
              Add Category
            </Button>
          </div>
        </header>

        <List
          collection={this.props.categories}
          headers={[ 'name', 'priority' ]}

          getRowLink={this.getRowLink}
          getRowColumns={this.getRowColumns}

          filter={'name'}
          filterPlaceholder='search categories'

          sort={'priority'}
        />
      </div>
    )
  }
}

Categories.propTypes = {
  categories: PropTypes.array.isRequired
}

Categories.defaultProps = {
  categories: []
}

export default Categories



// WEBPACK FOOTER //
// ./src/components/Categories/Categories.js